import { Eye, X, Clock, FolderKanban } from 'lucide-react';
import { useImpersonation } from '../../contexts/ImpersonationContext';
import { useProject } from '../../contexts/ProjectContext';
import { useTranslation } from 'react-i18next';

const ImpersonationBanner = () => {
  const { t } = useTranslation();
  const {
    isImpersonating,
    impersonatedTenant,
    startedAt,
    actionsCount,
    endImpersonation,
    isLoading
  } = useImpersonation();
  const { currentProject } = useProject();

  if (!isImpersonating || !impersonatedTenant) {
    return null;
  }

  const formatDuration = () => {
    if (!startedAt) return '';
    const start = new Date(startedAt);
    const now = new Date();
    const diffMs = now.getTime() - start.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    if (diffMins < 1) return 'Just started';
    if (diffMins < 60) return `${diffMins}m`;
    const hours = Math.floor(diffMins / 60);
    const mins = diffMins % 60;
    return `${hours}h ${mins}m`;
  };

  const handleEndSession = async () => {
    await endImpersonation();
    window.location.href = '/admin';
  };

  return (
    <div className="bg-amber-500 text-amber-950">
      <div className="max-w-screen-2xl mx-auto px-4 py-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <Eye className="h-4 w-4" />
              <span className="font-medium">
                {t('admin.viewingAs', 'Viewing as')}
              </span>
              <span className="font-bold">
                {impersonatedTenant.name}
              </span>
              <span className="text-amber-800 text-sm">
                ({impersonatedTenant.domain})
              </span>
            </div>

            <div className="hidden sm:flex items-center gap-4 text-sm text-amber-800">
              {currentProject && (
                <div className="flex items-center gap-1.5 bg-amber-400/40 px-2.5 py-1 rounded-md">
                  <FolderKanban className="h-3.5 w-3.5" />
                  <span className="font-medium">{currentProject.name}</span>
                </div>
              )}
              <div className="flex items-center gap-1">
                <Clock className="h-3.5 w-3.5" />
                <span>{formatDuration()}</span>
              </div>
              <div>
                {actionsCount} {t('admin.actions', 'actions')}
              </div>
            </div>
          </div>

          <button
            onClick={handleEndSession}
            disabled={isLoading}
            className="flex items-center gap-2 px-3 py-1.5 bg-amber-600 hover:bg-amber-700 text-white rounded-lg text-sm font-medium transition-colors disabled:opacity-50"
          >
            <X className="h-4 w-4" />
            <span className="hidden sm:inline">
              {t('admin.endSession', 'End Session')}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
